import { Injectable } from "@angular/core";
import { Product } from "src/app/shared/graphql/generated/graphql";
import { DashboardUtils } from "../../DashboardUtils";

type MethodologyLimitCategory = {
  byRegionalId: Map<string, string[]>;
  byAnalysisId: Map<string, string[]>;
};

type ProductMethodologiesLimiter = Map<number, MethodologyLimitCategory>;

@Injectable({
  providedIn: 'root'
})
export class ProductMethodologiesLimiterService {
  private productMethodologiesLimitMap: ProductMethodologiesLimiter = new Map([
    [1, {
      byRegionalId: new Map([
        ['8', ['1']]
      ]),
      byAnalysisId: new Map([
        ['8', ['1']]
      ])
    }],
    [4, {
      byRegionalId: new Map([
        ['8', ['7']]
      ]),
      byAnalysisId: new Map([
        ['8', ['7']]
      ])
    }],
  ])

  fromDashboardId(product: Product | undefined, dashboardId: string): string[] | undefined {
    const {regionalId, analysisId} = DashboardUtils.decodeDashboardId(dashboardId);

    const limiter = this.productMethodologiesLimitMap.get(product!.id);
    if (regionalId && limiter?.byRegionalId.has(regionalId.toString())) {
      return limiter?.byRegionalId.get(regionalId.toString());
    } else if (analysisId && limiter?.byAnalysisId.has(analysisId.toString())) {
      return limiter?.byRegionalId.get(analysisId.toString());
    } else {
      const methodologies = (product?.productMethodologies.map(pm => pm!.methodologyId.toString())) ?? [] as string[];
      return methodologies;
    }
  }
}
